import { SelectDos } from "../plugins/select2";
import {
    getData,
    CSRF,
    setSelect2Ajax,
    b64Uri,
    getJson,
    Management,
} from "../helpers";

/**
 * Implementar el plugin Select2 para las empresas
 *
 */
export class SelectPurchaseInvoice extends HTMLSelectElement {
    async connectedCallback() {
        // let management = getData(this, "data-management");

        let configSelect = {
            ajax: {
                url: getData("purchaseInvoicesUrlSelect"),
                type: "post",
                dataType: "json",
                cache: true,
                data: function (param) {
                    return {
                        _token: CSRF,
                        search: param.term,
                        management: Management,
                        // limit: 10,
                    };
                },
                processResults: function (response) {
                    // response.forEach((element) => {
                    //     element.id = element.alpha2;
                    // });
                    return {
                        results: response,
                    };
                },
            },
            // templateResult: (data) => ucwords(data.text),
            // templateSelection: (data) => {
            //     if (!data.id) {
            //         return data.text;
            //     }
            //     return `${data.alpha2}`;
            // },
        };

        const SD = new SelectDos(configSelect);
        const S = await SD.selectDos(this);

        if (getData(this, "data-default")) {
            let Data = getJson(b64Uri(getData(this, "data-default"), "decode"));
            if (Data?.id) {
                setSelect2Ajax(this, Data.id, `${Data.ref} (${Data.cif})`);
            }
        }
    }

    reset() {
        // this.dataS.notIn = [];
    }
}

window.customElements.define("select-purchaseinvoice", SelectPurchaseInvoice, {
    extends: "select",
});
